import React, { FC } from 'react'
import ReactDOM from 'react-dom'
import { PrimaryButton, SecondaryButton } from '..'

interface Props {
  show: boolean
  title?: string
  message?: string
  onCancel: () => void
  onConfirm: () => void
}

export const InventoryImportConfirmCloseModal: FC<Props> = ({
  show,
  title = 'Cambios sin guardar',
  message = '¿Seguro que desea cerrar? Tiene cambios sin guardar.',
  onCancel,
  onConfirm,
}) => {
  if (!show) return null
  return ReactDOM.createPortal(
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-[1000]">
      <div className="bg-white rounded shadow-lg w-[28rem] max-w-[90vw] p-4 relative">
        <div className="flex items-center justify-between mb-2">
          <h5 className="text-base font-semibold">{title}</h5>
        </div>
        <div className="text-sm text-gray-700 mb-4">{message}</div>
        <div className="flex justify-end gap-2">
          <SecondaryButton type="button" onClick={onCancel}>
            Cancelar
          </SecondaryButton>
          <PrimaryButton type="button" onClick={onConfirm}>
            Cerrar sin guardar
          </PrimaryButton>
        </div>
      </div>
    </div>,
    document.body
  )
}
